import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as n, renderSlot as H, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, A = { key: 1 }, M = { key: 2 }, k = { key: 3 }, Z = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconMinus"
}, V = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const r = a, { bind: d, weight: s } = m(r);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      H(i.$slots, "default"),
      n(s) === "bold" ? (o(), e("g", f, t[0] || (t[0] = [
        l("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z" }, null, -1)
      ]))) : n(s) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : n(s) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,136H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : n(s) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        l("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128Z" }, null, -1)
      ]))) : n(s) === "regular" ? (o(), e("g", Z, t[4] || (t[4] = [
        l("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : n(s) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        l("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  V as default
};
